/* eslint id-length: 0 */
import { createSelector } from 'reselect';
import { parse } from 'qs';

import { JOBS_SIZE } from '../../constants';
import * as helpers from './helpers';
import * as constants from './constants';
import { tryMapIdsToLabels } from '../container/utils';

export const query = (store) => store.apps.archives.query;
export const location = (store) => store.router.location;
export const user = (store) => store.user;

export const buildFullQuerySelector = createSelector([
  query,
], (queryStore) => {
  const filters = queryStore.get('filters').toJSON();
  const filterDate = queryStore.get('filterDate');
  const filterTeam = filters[constants.TEAM_FILTER];
  const inputQuery = queryStore.get('inputQuery');

  if (filterTeam) {
    filterTeam.selectedItems = tryMapIdsToLabels({
      ids: filterTeam.selectedItems,
      labels: filterTeam.labels,
    });
  }

  const normalizedFilters = helpers.getFiltersWithSelectedItems({
    ...filters,
    date: { selectedItems: [filterDate.get('startDate'), filterDate.get('endDate')] },
  });

  return helpers.unionQuery({ input: inputQuery, filters: normalizedFilters });
});

export const queryFromURLSelector = createSelector([
  query,
  location,
], (queryStore, routerLocation) => {
  const filters = queryStore.get('filters');
  const { search } = routerLocation;
  if (!search) {
    return null;
  }

  const parsedQuery = parse(search, { ignoreQueryPrefix: true, arrayLimit: 100 });
  const queryWithLabels = helpers.mapFiltersLabels(filters, parsedQuery.q);

  return {
    queryWithLabels,
    queryString: helpers.unionQuery({ input: '', filters: queryWithLabels }),
    page: parsedQuery.page ? Number(parsedQuery.page) : 0,
  };
});

export const searchQueryParamSelector = createSelector([
  user,
  query,
  buildFullQuerySelector,
], (userStore, queryStore, fullQuery) => {
  let queryString = fullQuery;
  const queryJSON = queryStore.get('query').toJSON();
  const scopeParam = helpers.getScopeParam(userStore);
  const v11Params = { ...scopeParam };
  const filters = queryStore.get('filters');

  const teamIds = filters.getIn(['teams', 'selectedItems']).toArray();
  // When team_id is in scopeParam, add it to other team ids and deduplicate them
  v11Params.team_id = scopeParam.team_id ?
    Array.from(new Set([...teamIds, scopeParam.team_id])) : teamIds;
  v11Params.owner = filters.getIn(['owner', 'selectedItems']).toArray();

  // Add org_id when any team is selected
  if (v11Params.team_id && v11Params.team_id.length !== 0) {
    v11Params.org_id = userStore.get('organization').id;
  }

  const queryWithLabels = helpers.mapFiltersLabels(filters, fullQuery, true);
  queryString = helpers.unionQuery({ input: '', filters: queryWithLabels });

  const parsed = parse({ ...queryJSON, q: queryString });

  return {
    urlQueryString: parsed,
    searchQueryParam: {
      ...parsed,
      q: helpers.serializeQuery(parsed.q),
      ...v11Params,
      per_page: JOBS_SIZE,
    },
  };
});
